import React from 'react';
import PropTypes from 'prop-types';
import {
  WrapperRadio,
  StyledLabel,
  StyledRadio,
  StyledCheckable
} from './style';

const RadioButton = ({
  className,
  ellipse,
  label,
  required,
  name,
  value,
  checked,
  disabled,
  onChange,
  id
}) => (
  <WrapperRadio className={className}>
    <StyledCheckable ellipse={ellipse} checked={checked} disabled={disabled} />
    <StyledRadio
      required={required}
      disabled={disabled}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      checked={checked}
    />
    <StyledLabel htmlFor={id} checked={checked} disabled={disabled}>
      {label}
    </StyledLabel>
  </WrapperRadio>
);

RadioButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // Le pasamos PropTypes.node para que pueda recibir HTML el Label
  required: PropTypes.bool,
  ellipse: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  id: PropTypes.string
};

RadioButton.defaultProps = {
  required: false,
  ellipse: false
};

export default RadioButton;
